import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "px-4 py-3 flex flex-col bg-white rounded-md" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row lg:justify-between items-center" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "font-medium text-lg" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-wrap"
}
const _hoisted_6 = { class: "text-sm text-gray-400 mt-1" }
const _hoisted_7 = { class: "text-gray-400 mt-1" }
const _hoisted_8 = {
  key: 1,
  class: "mt-1 flex items-center text-xs text-primary-500"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "導入スクールが作成した学習室です", -1)
const _hoisted_10 = { class: "flex items-center lg:m-0 mt-4 flex-wrap lg:flex-nowrap gap-y-4" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 強制終了 ")
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "ホスト入室", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "入室", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "mr-2" }, "入室生徒一覧", -1)
const _hoisted_15 = { class: "flex justify-between items-center" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 入室中の生徒に一斉メッセージ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_table = _resolveComponent("m-table")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.room.data.name) + " | 利用生徒数: " + _toDisplayString(_ctx.registrants.length) + "人 ", 1),
        (_ctx.isAdmin || _ctx.isTutorOfRoom)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("p", _hoisted_6, "閉室予定時刻: " + _toDisplayString(_ctx.endTime), 1),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", {
                  class: "ml-2 rounded-md cursor-pointer hover:bg-gray-100",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editEndTime && _ctx.editEndTime(...args)))
                }, [
                  _createVNode(_component_m_icon, { type: "pencil" })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAdmin && !_ctx.isOwnerOfRoom)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_m_icon, {
                type: "warning",
                class: "mr-2"
              }),
              _hoisted_9
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_10, [
        (_ctx.isAdmin || _ctx.isTutorOfRoom)
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 0,
              color: "red-400",
              "hover-color": "red-500",
              outline: "",
              class: "mr-4",
              onClick: _ctx.deleteRoom
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isTutorOfRoom)
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 1,
              color: "secondary-500",
              "hover-color": "secondary-600",
              outline: "",
              class: "mr-4",
              onClick: _ctx.joinHost
            }, {
              default: _withCtx(() => [
                _createVNode(_component_m_icon, {
                  type: "login",
                  class: "mr-2"
                }),
                _hoisted_12
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isAdmin || _ctx.isOwnerOfRoom)
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 2,
              color: "primary-500",
              "hover-color": "primary-600",
              onClick: _ctx.joinRoom
            }, {
              default: _withCtx(() => [
                _createVNode(_component_m_icon, {
                  type: "login",
                  class: "mr-2"
                }),
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.acceccableRegistrants.length > 0)
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 3,
              color: "gray-400",
              "hover-color": "primary-500",
              "font-weight": "normal",
              text: "",
              class: "ml-4 flex",
              onClick: _ctx.changeAccordionStatus
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _createVNode(_component_m_icon, {
                  type: "chevron-down",
                  class: ["transform", { 'rotate-180': _ctx.isDisplayedStudents }]
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createVNode(_component_m_table, {
      datas: _ctx.datas,
      definitions: _ctx.definitions,
      class: "mt-4 flex"
    }, {
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_m_button, {
            color: "secondary-500",
            "hover-color": "secondary-600",
            outline: "",
            class: "mr-6",
            onClick: _ctx.openSendModal
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["datas", "definitions"]), [
      [_vShow, _ctx.isDisplayedStudents]
    ])
  ]))
}